import React from 'react';
import { useTranslation } from 'react-i18next';

import Tick from '@/assets/icon-tick.svg?react';

import classes from './styles.module.scss';

interface Props {
    inclusions: string[];
}

export default function Inclusions({ inclusions }: Props) {
    const { t } = useTranslation();

    return inclusions && inclusions.length ? (
        <>
            <span className={`${classes.descriptionsInclusions}`}>
                {t('stack:inclusions')}
            </span>
            <div className={`${classes.description}`}>
                {inclusions.slice(0, 4).map((text, index) => (
                    <div className={classes.inclusion} key={`${index}_inclusion_idx`}>
                        <span className={classes.tick}>
                            <Tick />
                        </span>
                        {/* Inclusions come from RapidStor (descriptor /
                        deal content); flagged for Automate's translate
                        inspector. Stamped explicitly because the text is a
                        .map() param the rs-setting build plugin can't trace. */}
                        <span className={classes.text} data-rs-setting="descriptor.descriptions">{text}</span>
                    </div>
                ))}
            </div>
        </>
    ) : null;
}
